﻿//Jquery
import "./jquery-global.js";
import $, {ajax} from "jquery";

import 'jquery-validation';
import 'jquery-validation-unobtrusive';

export function initButtonLoader() {
    $('button[data-button-loader]').on("click", function (e) {
        e.preventDefault();
        let self = $(this);
        let form = $(this).closest('form');
        if (form.length > 0) {
            if (form.find('input:not([type="hidden"])').length > 0) {
                if (form.valid()) {
                    self.prop('disabled', true);
                    self.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span class="visually-hidden">Loading...</span>');
                    form.submit();
                }
            }
            else{
                self.prop('disabled', true);
                self.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span class="visually-hidden">Loading...</span>');
                form.submit();
            }
        }
    });
    $('a[data-button-loader]').on("click", function (e) {
        let self = $(this);
        self.css('width', Math.round(self.width()) + "px !important");
        self.css('height', Math.round(self.height()) + "px !important");
        self.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span class="visually-hidden">Loading...</span>');
    });
}
